import { navigateToMainFeed } from "../pages/mainfeedpage.js"
import { navigateToRecord } from "../pages/recordpage.js"
import { navigateToUserPage } from "../pages/userpage.js"
import { displaySignInButtonOnTopMenu, showSignIn } from "../../login/login-display.js"
import  {Popover} from 'bootstrap'

export function popoverInit() {
    //  popovers Initialization
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => new Popover(el, { html: true }));

    const signInModals = document.getElementsByClassName('signInModal');
    Array.from(signInModals).forEach((modal) => {
        modal.addEventListener('show.bs.popover', displaySignInButtonOnTopMenu);
        modal.addEventListener('shown.bs.popover', () => {
            const popoverId = modal.getAttribute('aria-describedby')
            const signInLink = popoverId ? document.getElementById(popoverId)?.querySelector<HTMLAnchorElement>('.signInLink') : null
            signInLink?.addEventListener('click', (event) => {
                event.preventDefault()
                showSignIn()
            }, { once: true })
        })
    });
}
const DEVICE = {
    // NOTE: Currently, the Samsung internet browser does not auto-play the next record when saving the address history.
    isAllowedToAddHistory: () => !navigator.userAgent.match(/SamsungBrowser/i)
}

const getHistoryState = (): Record<string, unknown> => window.history.state ?? {}
export const getRecordsHistoryIndex = (): number => {
    const index = window.history.state?.recordsHistoryIndex
    return typeof index == "number" && Number.isInteger(index) && index >= 0 ? index : 0
}

if (DEVICE.isAllowedToAddHistory() && window.history.state?.recordsHistoryIndex == null) {
    window.history.replaceState({ ...getHistoryState(), recordsHistoryIndex: 0 }, "", window.location.href)
}

export const PATH = {
    MAIN: { id: "record-main-page", init: () => navigateToMainFeed() },   // records
    USERPAGE: { id: "user-page", init: () => navigateToUserPage() },      // u
    RECORDPAGE:{ id: "record-page", init: () => navigateToRecord() },  // r
    OTHER: { id:"other", init: () => {} },
    // NOTE: CurrentPathWithQueries should be updated regardless of history state change
    addHistory: (pathWithQueries: string, shouldPushState = true) => {
        if (PATH.isChanged(pathWithQueries)) {
            localStorage.setItem("currentPathWithQueries", JSON.stringify(PATH.jsonize(pathWithQueries)))
            if (DEVICE.isAllowedToAddHistory() && shouldPushState)
                window.history.pushState({
                    ...getHistoryState(),
                    recordsHistoryIndex: getRecordsHistoryIndex() + 1,
                    previousRecordsPath: window.location.pathname
                }, "", pathWithQueries)
        }
    },
    // NOTE: For record views, the only difference between addHistory and replaceHistory is to replace the current state instead of pushing.
    replaceHistory: (pathWithQueries: string) => {
        if (PATH.isChanged(pathWithQueries)) {
            localStorage.setItem("currentPathWithQueries", JSON.stringify(PATH.jsonize(pathWithQueries)))
            if (DEVICE.isAllowedToAddHistory())
                window.history.replaceState({ ...getHistoryState(), recordsHistoryIndex: getRecordsHistoryIndex() }, "", pathWithQueries)
        }
    },
    getWindowPathWithQueries: () => window.location.pathname + window.location.search
    ,
    getCurrentPathType: () => PATH.getType(window.location.pathname)
    ,
    getType: (pathWithQueries: string) => {
        const queryIndex = pathWithQueries.indexOf("?")
        const p = (queryIndex > 0)? pathWithQueries.substring(0, queryIndex).split("/")[1] : pathWithQueries.split("/")[1]
        return p == "records" ? PATH.MAIN
            : p == "u" ? PATH.USERPAGE
            : p == "r" ? PATH.RECORDPAGE
            : PATH.OTHER
    },
    isChanged: (pathWithQueries: string) => {
        const current = PATH.jsonize(pathWithQueries)
        const previous = localStorage.getItem("currentPathWithQueries")
        return previous == null || previous != JSON.stringify(current)
    },
    jsonize: (pathWithQueries: string) => {
        const queryIndex = pathWithQueries.indexOf("?")
        const id = (queryIndex > 0)? pathWithQueries.substring(0, queryIndex).split('/')[2] : pathWithQueries.split('/')[2]
        const param = (queryIndex > 0) ? pathWithQueries.substring(queryIndex) : ""
        return {
            type: PATH.getType(pathWithQueries).id,
            id: id || "",
            param: param || ""
        } 
    },
    getUserId: () => window.location.pathname.replace("/u/", ""),
    // TODO: below isRecordPage() has been ignored. Find out why it was added. Then, remove or replace this after localStorage.getItem-related crash is removed.
//    isRecordPage: () => PATH.getCurrentPathType() == PATH.RECORDPAGE,
    // TODO: Samsung browser doesn't save the current address history, so be sure to completely separate how to get the current path and type.
//    isRecordPage: () => JSON.parse(localStorage.getItem("currentPathWithQueries"))?.type == PATH.RECORDPAGE.id // can't use optional chaining in iOS 12.5.5
    isRecordPage: () => {
        const currentPath = JSON.parse(localStorage.getItem("currentPathWithQueries") ?? 'null')
        return currentPath?.type == PATH.RECORDPAGE.id
    }
}
